import * as S from "./styles";

// Tabela de vínculos do projeto, abaixo do campo "Seletivas" (pedido do cliente,
// 18/08/2026): Patrocinador, Seletiva e Status da associação.
//
// Ela existe porque o campo passou a oferecer SÓ seletivas e deixou de mostrar o
// quadro completo — vínculo direto (sem seletiva) não aparece mais lá. Os rótulos
// vêm prontos do backend (`project_sponsor_links`), não ids.
//
// ⚠️ Reflete o BANCO, não a seleção pendente do campo: uma seletiva marcada só
// aparece aqui depois de "Atualizar".
const SponsorLinksTable = ({ links }) => {
  const rows = links || [];

  return (
    <S.Wrapper>
      <S.Title>Patrocinadores vinculados</S.Title>

      {rows.length === 0 ? (
        <S.Empty>Nenhum patrocinador vinculado a este projeto.</S.Empty>
      ) : (
        <S.Table>
          <thead>
            <tr>
              <th>Patrocinador</th>
              <th>Seletiva</th>
              <th>Status da Associação</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((link) => (
              <tr key={link.project_sponsor_id}>
                <td>{link.sponsor_name || "—"}</td>
                {/* Vínculo direto não tem seletiva: célula vazia, não "null". */}
                <td>{link.select_project_name || "—"}</td>
                <td>{link.status || "—"}</td>
              </tr>
            ))}
          </tbody>
        </S.Table>
      )}
    </S.Wrapper>
  );
};

export default SponsorLinksTable;
